'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@vue-storefront/core');

// @ts-ignore
var DEFAULT_INTERCEPT_INTEGRATIONS = {
    '$ct': true,
    '$cntf': true,
};
var plugin = function (context) {
    var _a = context.app, $vsf = _a.$vsf, vmoproxy = _a.$config.vmoproxy;
    if (!vmoproxy && !vmoproxy.regexpTest) {
        core.Logger.error('vmoproxy: "regexpTest" not defined');
        return;
    }
    var registerFulfilled = function (key) {
        var fulfilled = function vmoproxyFulfilled(request) {
            if (vmoproxy.regexpTest.test(request.url)) {
                var cookiesData = void 0;
                if (process.client && vmoproxy.useCookies && Array.isArray(vmoproxy.useCookies)) {
                    if (!document.cookie) {
                        $vsf[key].client.interceptors.request.forEach(function (handler) {
                            if (handler.fulfilled && handler.fulfilled.name !== 'vmoproxyFulfilled') {
                                handler.fulfilled(request);
                            }
                        });
                    }
                    // @ts-ignore
                    cookiesData = (document.cookie || '').split(';')
                        .filter(function (item) { return vmoproxy.useCookies.indexOf(item.trim().split('=')[0]) >= 0; })
                        .join(';')
                        .trim();
                }
                var payload = {
                    url: request.url,
                    data: request.data,
                };
                if (cookiesData) {
                    payload.cookie = cookiesData;
                }
                var urlAppend = encodeURIComponent(Buffer.from(JSON.stringify(payload)).toString('base64'));
                // if more than 950 chars then provide original destination, otherwise we might hit URL length limit.
                if (urlAppend.length > 950) {
                    return request;
                }
                return Object.assign({}, request, {
                    url: '/vmoproxy/' + urlAppend,
                    method: 'get',
                });
            }
            return request;
        };
        return fulfilled;
    };
    var rejected = function (error) {
        core.Logger.error('vmoproxy: interceptor rejected', error);
        return Promise.reject(error);
    };
    var options = {
        synchronous: false,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        runWhen: function (config) {
            // Logger.error('interceptor runWhen', config);
            return true;
        },
    };
    Object.keys(vmoproxy.integrations || DEFAULT_INTERCEPT_INTEGRATIONS).forEach(function (key) {
        if (!$vsf[key]) {
            if (vmoproxy.integrations[key]) {
                core.Logger.error("vmoproxy: Key \"".concat(key, "\" is not defined integration"));
            }
            return;
        }
        $vsf[key].client.interceptors.request.use(registerFulfilled(key), rejected, options);
    });
    return true;
};

exports["default"] = plugin;
exports.plugin = plugin;
//# sourceMappingURL=index.js.map
